/*
 * Cadwork webgl Engine
 * http://www.lexoview.com
 *
 * Copyright (C) 2015 Cadwork Informatik AG, Basel, Switzerland
 * Dual licensed under the MIT and GPL
 *
 * @author Jaroslav Přibyl (pribyl@cadwork.cz)
 *
 */

import Batch, {UPDATETYPES} from "App/render/webgl/renderables/batches/batch";
import WebGLRenderGraph from "App/render/webgl/render_graph";
import ShapeBatchNode from "App/render/webgl/nodes/shape_batch_node";
import Pass from "App/render/webgl/passes/pass";
import WebGLContext from "App/web_gl_context";
import IScene from "js_interface/src/scene_interface";

export default
class PointCloudBatch extends Batch {

    public static TypeName: string = "PointCloudBatch";

    constructor(aSceneAPI: IScene, aRenderGraph: WebGLRenderGraph, aShapeBatchNode: ShapeBatchNode) {
        super(aSceneAPI, aRenderGraph, aShapeBatchNode);
    }

    public static create(aSceneAPI: IScene, aRenderGraph: WebGLRenderGraph, aShapeBatchNode: ShapeBatchNode): PointCloudBatch {
        return new PointCloudBatch(aSceneAPI, aRenderGraph, aShapeBatchNode);
    }

    public reCreate(aVerticesCount: number, aIndicesCount: number) {
        super.reCreate(aVerticesCount, aIndicesCount);

        this._attributes.reCreateBuffer([
            [aVerticesCount, 3], // vertex
            [aVerticesCount, 1]  // color
        ]);
    }

    public update() {
        // INDEXED GEOMETRY
        this._attributes.bindBuffer();

        let shape;
        let geometry;
        let placement;
        let shapes = this.shapeBatchNode.placements.getObjectsArray();
        for (let i = 0; i < shapes.length; i++) {
            shape = shapes[i];
            if (shape.hasData()) {
                geometry = shape.getGeometry();
                placement = shape.getPlacement();

                if (placement.updates[UPDATETYPES.VERTEX]) {
                    this.updateVertices(placement, geometry, 0);
                }

                if (placement.updates[UPDATETYPES.COLOR] && geometry.colorsDesc) {
                    this.updateAttributes(placement.buffer.vertexOffset, geometry.colorsDesc.data, 1);
                }

                placement.updates = {};
                placement.placed = true;
            }
        }

        this._attributes.unbindBuffer();
    }

    public render(aRenderPass: Pass) {
        let shader: any = aRenderPass.getActiveShaderRenderable();
        let gl = (<WebGLContext>this._context).getWebGLRenderingContext();

        gl.bindBuffer(gl.ARRAY_BUFFER, this._attributes.getWebglBuffer());

        gl.vertexAttribPointer(shader.attributeLocations.a_position, 3, gl.FLOAT, false, 0, this._attributes.members[0].offset);
        gl.vertexAttribPointer(shader.attributeLocations.a_color, 1, gl.FLOAT, false, 0, this._attributes.members[1].offset);

        gl.drawArrays(gl.POINTS, 0, this._verticesCount);
    }
}
